import React, { ReactNode } from 'react';
import {
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  BoxProps,
  useTheme
} from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';
import { ActivityDetailCardEmptyStateLayout } from 'modules/components/layer01';



export type ActivityDetailSectionCardBaseLayoutProps = {
  title: string;
  subTitle: string;
  children?: ReactNode;
  editActionButton: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  } | null;
  actionButton: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  } | null;
  isEmpty?: boolean;
  boxProps?: BoxProps;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityDetailSectionCardBaseLayoutProps & BoxProps) => {
  const theme = useTheme();
  return (
    <Box
      {...props.boxProps}
      display='flex'
      flexDirection='column'
      border={`1px solid ${theme.palette.secondary.dark}`}
      borderRadius='1.25rem'
      paddingY='1.25rem'
      overflow={
        props.isEmpty
          ? 'clip'
          : 'auto'
      }
      paddingBottom={
        props.isEmpty
          ? '0rem'
          : '1.25rem'
      }
      rowGap='1rem'
    >
      {/* HEADER */}
      <Stack
        paddingX='2.25rem'
        rowGap='.25rem'
      >
        <Stack
          justifyContent='space-between'
          direction='row'
        >
          <Typography
            variant='modalTitle'
          >
            {props.title}
          </Typography>
          {
            props.editActionButton && (
              <IconButton
                disabled={props.editActionButton.disabled}
                onClick={props.editActionButton.onClick}
                sx={{
                  height: '1rem'
                }}
              >
                <CustomIcon.large.FC
                  icon='EDITALT'
                  stroke={props.editActionButton.disabled ? theme.palette.grey[300] : theme.palette.primary.main}
                />
              </IconButton>
            )
          }
        </Stack>
        <Typography
          variant='modalSubTitle'
        >
          {props.subTitle}
        </Typography>
      </Stack>

      {/* DETAIL */}

      <Stack
        padding={
          props.isEmpty
            ? '0rem'
            : '1rem'
        }
        paddingX={
          props.isEmpty
            ? '0rem'
            : '2rem'
        }
        rowGap='1rem'
      >
        {props.isEmpty
          ? (
            <ActivityDetailCardEmptyStateLayout.FC
              title={`No ${props.title} Found`}
              description={`Add ${props.title} to get started`}
            />
          )
          : props.children}
      </Stack>



      {/* ACTIONS */}
      {(props.actionButton) && (

        <Box
          margin='auto'
        >
          <Button
            variant='text'
            color='primary'
            disabled={props.actionButton.disabled}
            onClick={() => props.actionButton && props.actionButton.onClick()}
            startIcon={(
              <CustomIcon.large.FC
                icon='PLUS'
                stroke={props.actionButton.disabled ? theme.palette.grey[300] : theme.palette.primary.main}
              />
            )}
          >
            {props.actionButton.text}

          </Button>
        </Box>
      )}
    </Box>
  );
};
